<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="padding-b pb-md-12"
      maxwidth-container="810px"
    >
      <Loading v-if="loading" />
      <ErrorServidor v-else-if="erro" />
      <template v-else>
        <TituloPagina
          class="mt-5"
          :titulo="tituloDaPagina"
        />

        <p
          class="pa-0 mt-5 mt-md-6 mb-0 primary--text"
          data-cy="texto_da_pagina"
        >
          Cadastre uma conta bancária e tenha eventuais transações
          (se necessárias) facilitadas, como pedidos de reembolso.
        </p>

        <template v-if="listaContas.length > 0">
          <template v-if="loadingLista">
            <v-skeleton-loader
              v-for="n in quantCardsLoading"
              :key="n"
              transition="transition"
              type="list-item-three-line"
              class="mt-6"
              loading
            />
          </template>
          <ListaContasBancarias
            v-else
            :lista-contas-bancarias="listaContas"
            @excluirCard="excluirCard($event)"
            @setPrincipal="setPrincipal"
          />
        </template>

        <template v-else>
          <v-img
            :alt="imgAlt"
            :src="require(`@/assets/img/${imgSrc}`)"
            :height="imgHeight"
            :width="imgWidth"
            class="mt-10 mx-md-auto"
          />
        </template>

        <div
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile',
            $vuetify.breakpoint.mdAndUp && listaContas.length < 1
              ? 'botoes-rodape--menor mx-md-auto' : '',
          ]"
          class="grey lighten-3 botoes-rodape pa-3 mt-md-12 px-md-0"
        >
          <v-btn
            :width="$vuetify.breakpoint.mdAndUp ? '278' : '143'"
            color="primary"
            outlined
            exact
            to="/meu-perfil"
            data-cy="btn_voltar"
          >
            Voltar
          </v-btn>

          <v-btn
            :width="$vuetify.breakpoint.mdAndUp ? '278' : '143'"
            color="primary"
            to="/meu-perfil/contas-bancarias/cadastrar"
            data-cy="btn_cadastrar_conta_bancaria"
          >
            Nova Conta
          </v-btn>
        </div>
        <SnackBar
          :mensage="snackBar.message"
          :snackbar="snackBar.show"
          :button="true"
          :color="snackBar.color"
          :timeout="snackBar.timeout"
          @changeSnackBar="value => this.snackBar.show = value.visible"
        />
      </template>
    </InternaMain>
  </Wrapper>
</template>

<script>

import api from '@/api';

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import Loading from '@/components/Loading.vue';
import ListaContasBancarias from '@/components/MeuPerfil/ContasBancarias/ListaContasBancarias.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'ContasBancarias',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    ErrorServidor,
    Loading,
    SnackBar,
    ListaContasBancarias,
  },

  data() {
    return {
      erro: false,
      loading: true,
      totalContas: 0,
      loadingLista: false,
      quantCardsLoading: 1,
      listaContas: {},
      imgAlt: 'Imagem ilustrativa para cadastre uma conta bancária.',
      imgHeight: '183',
      imgSrc: 'contas-bancarias.svg',
      imgWidth: '297',
      tituloDaPagina: 'Contas Bancárias',
      urlApi: {
        contaBancaria: '/bank-account',
        setPrincipal: '/bank-account/set-main/',
      },
      snackBar: {
        message: '',
        color: 'success',
        timeout: 6000,
        show: false,
      },
      snackBarMensagens: {
        error: 'Tente novamente mais tarde.',
      },
    };
  },

  created() {
    this.getListaContasBancarias(true);
  },

  methods: {
    getListaContasBancarias(pagina = false, listaContasBancarias = false) {
      if (pagina) this.loading = true;
      if (listaContasBancarias) this.loadingLista = true;
      this.quantCards(true);

      api.get(this.urlApi.contaBancaria)
        .then((response) => {
          this.listaContas = Object.values(response.data);

          if (listaContasBancarias) {
            this.snackBar.message = 'Conta bancária excluída';
            this.snackBar.color = 'success';
            this.snackBar.show = true;
          }
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          if (pagina) this.loading = false;
          if (listaContasBancarias) this.loadingLista = false;
          this.totalContas = Object.keys(this.listaContas).length;
        });
    },

    excluirCard(id) {
      this.loadingLista = true;
      this.quantCards(true);

      api.delete(`${this.urlApi.contaBancaria}/${id}`)
        .then(() => {
          this.getListaContasBancarias(false, true);
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : this.snackBarMensagens.error;
          this.setSnackbar(errorMessage, 'error');
          this.loadingLista = false;
        });
    },

    setPrincipal(index, id) {
      this.loadingLista = true;
      this.quantCards();

      api.put(`${this.urlApi.setPrincipal}${id}`)
        .then(() => {
          this.listaContas.forEach((itemLista) => {
            const item = itemLista;
            item.is_main = false;
          });
          this.listaContas[index].is_main = true;
          this.loadingLista = false;
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : this.snackBarMensagens.error;
          this.setSnackbar(errorMessage, 'error');
        })
        .finally(() => {
          this.loadingLista = false;
        });
    },

    quantCards(menosUm = false) {
      if (menosUm) {
        this.quantCardsLoading = (this.listaContas.length <= 2)
          ? 1
          : this.listaContas.length - 1;
      } else {
        this.quantCardsLoading = this.listaContas.length;
      }
    },

    setSnackbar(mensagem, status = 'success', timeout = 6000) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
    },

  },

};

</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
